import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import { callAPI } from './apiActions';
import { openModal, MODAL_TYPES } from './modalActions';
export var GET_API_KEYS_REQUESTED = 'GET_API_KEYS_REQUESTED';
export var GET_API_KEYS_SUCCESS = 'GET_API_KEYS_SUCCESS';
export var GET_API_KEYS_ERROR = 'GET_API_KEYS_ERROR';
export var ADD_API_KEY = 'ADD_API_KEY';
export var REMOVE_API_KEY_SUCCESS = 'REMOVE_API_KEY_SUCCESS';
export var createApiKey = function createApiKey(formValues) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var UserId, Permissions, apiKey;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              UserId = getState().user.userInfo.UserId;
              Permissions = [];
              if (formValues.trading) Permissions.push('Trading');
              if (formValues.withdraw) Permissions.push('Withdraw');
              if (formValues.deposit) Permissions.push('Deposit');
              if (formValues.accountReadOnly) Permissions.push('AccountReadOnly');
              _context.next = 8;
              return dispatch(callAPI('AddUserAPIKey', {
                UserId: UserId,
                Permissions: Permissions
              }));
            case 8:
              apiKey = _context.sent;
              dispatch(openModal(MODAL_TYPES.NEW_API_KEY, {
                apiKey: apiKey
              }));
            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var getUserApiKeys = function getUserApiKeys(UserId) {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      var keys;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch(getApiKeysRequested());
              _context2.next = 3;
              return dispatch(callAPI('GetUserAPIKeys', {
                UserId: UserId
              }));
            case 3:
              keys = _context2.sent;
              if (Array.isArray(keys)) {
                dispatch(getApiKeysSuccess(keys));
              }
            case 5:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));
    return function (_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var getApiKeysRequested = function getApiKeysRequested() {
  return {
    type: GET_API_KEYS_REQUESTED
  };
};
export var getApiKeysSuccess = function getApiKeysSuccess(payload) {
  return {
    type: GET_API_KEYS_SUCCESS,
    payload: payload
  };
};
export var addApiKey = function addApiKey(payload) {
  return {
    type: ADD_API_KEY,
    payload: payload
  };
};
export var removeApiKeySuccess = function removeApiKeySuccess(payload) {
  return {
    type: REMOVE_API_KEY_SUCCESS,
    payload: payload
  };
};
export var removeApiKey = function removeApiKey(APIKey) {
  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch, getState) {
      var UserId, response;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              UserId = getState().user.userInfo.UserId;
              _context3.next = 3;
              return dispatch(callAPI('RemoveUserAPIKey', {
                UserId: UserId,
                APIKey: APIKey
              }));
            case 3:
              response = _context3.sent;
              if (response.result) {
                dispatch(removeApiKeySuccess(APIKey));
              }
            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));
    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();
};